export const EurRestrictions = {
	"2025-01-02": {
		high: 37.48976503,
		low: 24.01187038
	},
	"2025-01-03": {
		high: 37.32412302,
		low: 23.82105949
	},
	"2025-01-06": {
		high: 37.64163842,
		low: 23.67409211
	},
	"2025-01-07": {
		high: 37.56844131,
		low: 24.05568795
	},
	"2025-01-08": {
		high: 37.98360483,
		low: 23.74687063
	},
	"2025-01-09": {
		high: 37.49233618,
		low: 23.94198455
	},
	"2025-01-10": {
		high: 37.35666794,
		low: 23.88411941
	},
	"2025-01-13": {
		high: 37.39553156,
		low: 23.71423182
	},
	"2025-01-14": {
		high: 38.03614883,
		low: 24.03011783
	},
	"2025-01-15": {
		high: 38.79041446,
		low: 24.80468115
	},
	"2025-01-16": {
		high: 40.67114344,
		low: 25.3353046
	},
	"2025-01-17": {
		high: 40.89853978,
		low: 25.8183984
	},
	"2025-01-20": {
		high: 41.22769594,
		low: 26.11305494
	},
	"2025-01-21": {
		high: 41.52410575,
		low: 26.16384659
	},
	"2025-01-22": {
		high: 41.42447605,
		low: 26.02509622
	},
	"2025-01-23": {
		high: 41.19440132,
		low: 25.97267031
	},
	"2025-01-24": {
		high: 41.39706253,
		low: 25.46934286
	},
	"2025-01-28": {
		high: 40.9341518,
		low: 25.46452599
	},
	"2025-01-29": {
		high: 40.48245013,
		low: 25.54167038
	},
	"2025-01-30": {
		high: 40.3555379,
		low: 25.45404057
	},
	"2025-01-31": {
		high: 41.05959442,
		low: 25.98987708
	},
	"2025-02-03": {
		high: 39.47029268,
		low: 24.87015496
	},
	"2025-02-04": {
		high: 40.01675806,
		low: 25.06748373
	},
	"2025-02-05": {
		high: 39.75387942,
		low: 25.11090259
	},
	"2025-02-06": {
		high: 40.77406384,
		low: 25.73964715
	},
	"2025-02-07": {
		high: 40.92961421,
		low: 26.13590127
	},
	"2025-02-10": {
		high: 40.37574594,
		low: 25.90367189
	},
	"2025-02-11": {
		high: 40.45291759,
		low: 25.77385968
	},
	"2025-02-12": {
		high: 40.23583928,
		low: 25.28788374
	},
	"2025-02-13": {
		high: 40.23163439,
		low: 24.64210285
	},
	"2025-02-14": {
		high: 39.66217932,
		low: 24.71976632
	},
	"2025-02-17": {
		high: 39.01757239,
		low: 24.24354853
	},
	"2025-02-18": {
		high: 38.89255779,
		low: 24.26937262
	},
	"2025-02-19": {
		high: 40.64480521,
		low: 24.52130509
	},
	"2025-02-20": {
		high: 39.48585724,
		low: 24.4902763
	},
	"2025-02-21": {
		high: 39.33501106,
		low: 24.57429802
	},
	"2025-02-24": {
		high: 39.14682918,
		low: 23.80031918
	},
	"2025-02-25": {
		high: 37.63938752,
		low: 23.49190201
	},
	"2025-02-26": {
		high: 39.04678425,
		low: 23.88389176
	},
	"2025-02-27": {
		high: 39.1782393,
		low: 24.30628418
	},
	"2025-02-28": {
		high: 38.39660352,
		low: 24.10786712
	},
	"2025-03-03": {
		high: 38.62872507,
		low: 24.03652899
	},
	"2025-03-04": {
		high: 38.46134551,
		low: 23.77140009
	},
	"2025-03-05": {
		high: 38.89332269,
		low: 23.51378893
	},
	"2025-03-06": {
		high: 39.07238229,
		low: 23.77173357
	},
	"2025-03-07": {
		high: 39.06332753,
		low: 23.51572218
	},
	"2025-03-10": {
		high: 38.52692641,
		low: 23.29912108
	},
	"2025-03-11": {
		high: 38.6041151,
		low: 23.11532629
	},
	"2025-03-12": {
		high: 38.14301419,
		low: 22.80187372
	},
	"2025-03-13": {
		high: 37.66636922,
		low: 22.74569055
	},
	"2025-03-14": {
		high: 38.06693518,
		low: 22.98334195
	},
	"2025-03-17": {
		high: 38.76674474,
		low: 23.33777761
	},
	"2025-03-18": {
		high: 38.96748257,
		low: 23.36309562
	},
	"2025-03-19": {
		high: 38.66070804,
		low: 22.74786805
	},
	"2025-03-20": {
		high: 36.78699679,
		low: 21.5654231
	},
	"2025-03-21": {
		high: 35.51515531,
		low: 21.11084706
	},
	"2025-03-24": {
		high: 32.40042989,
		low: 18.4966024
	},
	"2025-03-25": {
		high: 29.29964399,
		low: 17.55944828
	},
	"2025-03-26": {
		high: 28.91074645,
		low: 17.61659182
	},
	"2025-03-27": {
		high: 29.54334878,
		low: 17.56735518
	},
	"2025-03-28": {
		high: 29.84571666,
		low: 17.88498284
	},
	"2025-03-31": {
		high: 29.42624077,
		low: 17.50754544
	},
	"2025-04-01": {
		high: 28.51315137,
		low: 17.03535455
	},
	"2025-04-02": {
		high: 27.91330302,
		low: 16.66968835
	},
	"2025-04-03": {
		high: 28.94219028,
		low: 16.59566115
	},
	"2025-04-04": {
		high: 26.30726851,
		low: 15.10060453
	},
	"2025-04-07": {
		high: 25.03949447,
		low: 13.98749935
	},
	"2025-04-08": {
		high: 24.87466806,
		low: 14.47306505
	},
	"2025-04-09": {
		high: 24.60156851,
		low: 14.44205439
	},
	"2025-04-10": {
		high: 27.06570433,
		low: 15.48366003
	},
	"2025-04-11": {
		high: 26.35928829,
		low: 14.98659701
	},
	"2025-04-14": {
		high: 27.24805981,
		low: 15.67166695
	},
	"2025-04-15": {
		high: 26.94842053,
		low: 15.60629634
	},
	"2025-04-16": {
		high: 26.23000936,
		low: 15.16759233
	},
	"2025-04-17": {
		high: 26.81491421,
		low: 15.21494795
	},
	"2025-04-22": {
		high: 26.27475192,
		low: 15.08434414
	},
	"2025-04-23": {
		high: 27.38701616,
		low: 15.70279723
	},
	"2025-04-24": {
		high: 28.41742987,
		low: 16.19021615
	},
	"2025-04-28": {
		high: 29.43653912,
		low: 16.45755529
	},
	"2025-04-29": {
		high: 28.39677121,
		low: 16.33899703
	},
	"2025-04-30": {
		high: 28.58624465,
		low: 16.60335184
	},
	"2025-05-01": {
		high: 28.5243767,
		low: 16.66555398
	},
	"2025-05-02": {
		high: 29.56883612,
		low: 17.05099085
	},
	"2025-05-05": {
		high: 29.68356927,
		low: 16.99231725
	},
	"2025-05-06": {
		high: 29.24511153,
		low: 16.92207349
	},
	"2025-05-07": {
		high: 28.90359047,
		low: 16.7626467
	},
	"2025-05-08": {
		high: 28.54217592,
		low: 16.43784404
	},
	"2025-05-09": {
		high: 29.38031311,
		low: 16.96382198
	},
	"2025-05-12": {
		high: 29.84979552,
		low: 17.58576668
	},
	"2025-05-13": {
		high: 31.31521577,
		low: 18.08354109
	},
	"2025-05-14": {
		high: 30.99898469,
		low: 18.10815962
	},
	"2025-05-15": {
		high: 30.73335725,
		low: 17.83382243
	},
	"2025-05-16": {
		high: 30.15936,
		low: 17.56667187
	},
	"2025-05-19": {
		high: 30.09622894,
		low: 17.41574561
	},
	"2025-05-20": {
		high: 29.95781404,
		low: 17.38375441
	},
	"2025-05-21": {
		high: 28.49420849,
		low: 16.0406471
	},
	"2025-05-22": {
		high: 28.26814353,
		low: 16.34316321
	},
	"2025-05-23": {
		high: 28.89575811,
		low: 16.59501312
	},
	"2025-05-26": {
		high: 27.91312804,
		low: 16.10973371
	},
	"2025-05-27": {
		high: 27.75648006,
		low: 16.01199755
	},
	"2025-05-28": {
		high: 27.57521623,
		low: 15.75421656
	},
	"2025-05-29": {
		high: 26.81266304,
		low: 15.45254607
	},
	"2025-05-30": {
		high: 27.5889567,
		low: 15.89186389
	},
	"2025-06-02": {
		high: 28.68867361,
		low: 16.31735553
	},
	"2025-06-03": {
		high: 28.64803747,
		low: 16.22923961
	},
	"2025-06-04": {
		high: 30.15437326,
		low: 17.22372803
	},
	"2025-06-05": {
		high: 30.95691757,
		low: 17.72472342
	},
	"2025-06-06": {
		high: 31.78003233,
		low: 18.19799661
	},
	"2025-06-10": {
		high: 32.63667062,
		low: 18.67760534
	},
	"2025-06-11": {
		high: 32.95255176,
		low: 18.64486465
	},
	"2025-06-12": {
		high: 32.64191855,
		low: 18.30451757
	},
	"2025-06-13": {
		high: 32.05904863,
		low: 17.92634046
	},
	"2025-06-16": {
		high: 31.77025256,
		low: 18.01357753
	},
	"2025-06-17": {
		high: 30.77221877,
		low: 17.42274881
	},
	"2025-06-18": {
		high: 30.24186464,
		low: 16.9378523
	},
	"2025-06-19": {
		high: 29.25008263,
		low: 16.73989369
	},
	"2025-06-20": {
		high: 29.0946149,
		low: 16.49602823
	},
	"2025-06-23": {
		high: 28.86392849,
		low: 16.38188745
	},
	"2025-06-24": {
		high: 29.85639975,
		low: 16.80273829
	},
	"2025-06-25": {
		high: 30.78085216,
		low: 17.03322035
	},
	"2025-06-26": {
		high: 30.88108264,
		low: 17.25962825
	},
	"2025-06-27": {
		high: 31.06981239,
		low: 17.23813498
	},
	"2025-06-30": {
		high: 33.80270569,
		low: 18.35642786
	},
	"2025-07-01": {
		high: 32.86308364,
		low: 18.06837501
	},
	"2025-07-02": {
		high: 35.27971245,
		low: 18.91317631
	},
	"2025-07-03": {
		high: 34.38481245,
		low: 18.97615109
	},
	"2025-07-04": {
		high: 34.30884511,
		low: 18.89474366
	},
	"2025-07-07": {
		high: 34.05414874,
		low: 18.98015268
	},
	"2025-07-08": {
		high: 34.14936757,
		low: 19.00853316
	},
	"2025-07-09": {
		high: 33.79121956,
		low: 18.69227065
	},
	"2025-07-10": {
		high: 33.87039403,
		low: 19.04262637
	},
	"2025-07-11": {
		high: 34.12400837,
		low: 19.05260197
	},
	"2025-07-14": {
		high: 33.1023653,
		low: 18.51312199
	},
	"2025-07-15": {
		high: 32.33200706,
		low: 18.33387199
	},
	"2025-07-16": {
		high: 31.66941847,
		low: 17.806579
	},
	"2025-07-17": {
		high: 31.91613581,
		low: 17.86264665
	},
	"2025-07-18": {
		high: 32.19117905,
		low: 18.20123564
	},
	"2025-07-21": {
		high: 31.89740646,
		low: 17.99114043
	},
	"2025-07-22": {
		high: 31.81302801,
		low: 17.67513328
	},
	"2025-07-23": {
		high: 33.21363504,
		low: 18.41333129
	},
	"2025-07-24": {
		high: 33.50113331,
		low: 18.66482916
	},
	"2025-07-25": {
		high: 32.81185376,
		low: 18.34175535
	},
	"2025-07-28": {
		high: 32.60537947,
		low: 18.51056457
	},
	"2025-07-29": {
		high: 32.67657339,
		low: 18.57827639
	},
	"2025-07-30": {
		high: 32.84171528,
		low: 18.74783634
	},
	"2025-07-31": {
		high: 32.00143942,
		low: 18.52306299
	},
	"2025-08-01": {
		high: 31.53069153,
		low: 17.88676509
	},
	"2025-08-04": {
		high: 31.60815102,
		low: 17.85712852
	},
	"2025-08-05": {
		high: 32.11956522,
		low: 18.17462029
	},
	"2025-08-06": {
		high: 33.91192417,
		low: 18.73532785
	},
	"2025-08-07": {
		high: 33.6351302,
		low: 18.95003768
	},
	"2025-08-08": {
		high: 33.76565762,
		low: 19.11630658
	},
	"2025-08-11": {
		high: 34.24262355,
		low: 19.32850111
	},
	"2025-08-12": {
		high: 33.98745701,
		low: 19.10678227
	},
	"2025-08-13": {
		high: 34.77083129,
		low: 19.53064924
	},
	"2025-08-14": {
		high: 35.66439014,
		low: 20.0009873
	},
	"2025-08-15": {
		high: 35.88636245,
		low: 20.09299984
	},
	"2025-08-18": {
		high: 35.45654587,
		low: 19.77360466
	},
	"2025-08-19": {
		high: 34.7144876,
		low: 19.59269883
	},
	"2025-08-20": {
		high: 25.6291493,
		low: 13.72414235
	},
	"2025-08-21": {
		high: 23.23157111,
		low: 12.43864072
	},
	"2025-08-22": {
		high: 24.02631528,
		low: 13.36259551
	},
	"2025-08-25": {
		high: 24.78988602,
		low: 13.89920464
	},
	"2025-08-26": {
		high: 23.99439092,
		low: 13.28065605
	},
	"2025-08-27": {
		high: 24.36651231,
		low: 13.51883165
	},
	"2025-08-28": {
		high: 24.58942529,
		low: 13.75990983
	},
	"2025-08-29": {
		high: 24.87428807,
		low: 13.9554789
	},
	"2025-09-01": {
		high: 24.36979194,
		low: 13.47683266
	},
	"2025-09-02": {
		high: 23.97684455,
		low: 13.33591311
	},
	"2025-09-03": {
		high: 23.65259273,
		low: 13.35174431
	},
	"2025-09-04": {
		high: 23.25854116,
		low: 13.1138438
	},
	"2025-09-05": {
		high: 23.81454853,
		low: 13.3261006
	},
	"2025-09-08": {
		high: 24.64133909,
		low: 13.81431428
	},
	"2025-09-09": {
		high: 24.01105772,
		low: 13.38207596
	},
	"2025-09-10": {
		high: 23.66400603,
		low: 13.27010021
	},
	"2025-09-11": {
		high: 23.84534477,
		low: 13.39459878
	},
	"2025-09-12": {
		high: 24.61513919,
		low: 13.60561857
	},
	"2025-09-15": {
		high: 24.18958104,
		low: 13.5315245
	},
	"2025-09-16": {
		high: 24.19519758,
		low: 13.3862479
	},
	"2025-09-17": {
		high: 23.73251051,
		low: 13.25500771
	},
	"2025-09-18": {
		high: 23.24428314,
		low: 12.75749803
	},
	"2025-09-19": {
		high: 23.490331,
		low: 12.93508654
	},
	"2025-09-22": {
		high: 23.50736667,
		low: 13.04164507
	},
	"2025-09-23": {
		high: 23.59446032,
		low: 13.08987616
	},
	"2025-09-24": {
		high: 22.90181833,
		low: 12.56430612
	},
	"2025-09-25": {
		high: 21.88922015,
		low: 12.24991705
	},
	"2025-09-26": {
		high: 22.34019573,
		low: 12.48672248
	},
	"2025-09-29": {
		high: 22.64828294,
		low: 12.71825315
	},
	"2025-09-30": {
		high: 22.66515936,
		low: 12.63042304
	},
	"2025-10-01": {
		high: 23.17640836,
		low: 12.93429315
	},
	"2025-10-02": {
		high: 23.52041153,
		low: 13.25081612
	},
	"2025-10-03": {
		high: 23.95374013,
		low: 13.33588467
	},
	"2025-10-06": {
		high: 24.91695671,
		low: 13.81600116
	},
	"2025-10-07": {
		high: 24.19752762,
		low: 13.65583721
	},
	"2025-10-08": {
		high: 26.43224022,
		low: 14.72648492
	},
	"2025-10-09": {
		high: 26.50430269,
		low: 14.7959564
	},
	"2025-10-10": {
		high: 25.89676743,
		low: 14.5415891
	},
	"2025-10-13": {
		high: 25.77964744,
		low: 14.64965311
	},
	"2025-10-14": {
		high: 25.60278077,
		low: 14.34583365
	},
	"2025-10-15": {
		high: 26.92793438,
		low: 15.17761625
	},
	"2025-10-16": {
		high: 27.01490021,
		low: 15.08175638
	},
	"2025-10-17": {
		high: 26.22282256,
		low: 14.723779
	},
	"2025-10-20": {
		high: 26.16255218,
		low: 14.76951088
	},
	"2025-10-21": {
		high: 25.92212982,
		low: 14.70797846
	},
	"2025-10-22": {
		high: 26.22163992,
		low: 14.75307932
	},
	"2025-10-23": {
		high: 26.18599532,
		low: 14.76734542
	},
	"2025-10-24": {
		high: 26.81533682,
		low: 15.0553487
	},
	"2025-10-27": {
		high: 27.37786169,
		low: 15.38357512
	},
	"2025-10-28": {
		high: 27.83387086,
		low: 15.28602562
	},
	"2025-10-29": {
		high: 27.01086349,
		low: 15.23013335
	},
	"2025-10-30": {
		high: 25.91840212,
		low: 14.63250568
	},
	"2025-10-31": {
		high: 25.68259888,
		low: 14.59040141
	},
	"2025-11-03": {
		high: 25.26687367,
		low: 14.35221081
	},
	"2025-11-04": {
		high: 24.52841208,
		low: 13.77600607
	},
	"2025-11-05": {
		high: 23.25475532,
		low: 12.94834661
	},
	"2025-11-06": {
		high: 20.81454998,
		low: 10.95382781
	},
	"2025-11-07": {
		high: 21.03090374,
		low: 11.62942094
	},
	"2025-11-10": {
		high: 21.0557959,
		low: 11.76254395
	},
	"2025-11-11": {
		high: 20.7259701,
		low: 11.65710492
	},
	"2025-11-12": {
		high: 20.58292798,
		low: 11.55537559
	},
	"2025-11-13": {
		high: 20.62267476,
		low: 11.40748291
	},
	"2025-11-14": {
		high: 20.22758319,
		low: 11.31711371
	},
	"2025-11-17": {
		high: 20.34848996,
		low: 11.28784643
	},
	"2025-11-18": {
		high: 21.89533129,
		low: 11.97475834
	},
	"2025-11-19": {
		high: 21.52961293,
		low: 12.07813695
	},
	"2025-11-20": {
		high: 22.06859262,
		low: 12.30776636
	},
	"2025-11-21": {
		high: 21.73960747,
		low: 12.22724734
	},
	"2025-11-24": {
		high: 22.74716113,
		low: 12.39196086
	},
	"2025-11-25": {
		high: 22.62159593,
		low: 12.54832617
	},
	"2025-11-26": {
		high: 23.88398092,
		low: 13.23461225
	},
	"2025-11-27": {
		high: 23.69911608,
		low: 13.42771566
	},
	"2025-11-28": {
		high: 24.00911341,
		low: 13.52421919
	},
	"2025-12-01": {
		high: 23.77519917,
		low: 13.4088081
	},
	"2025-12-02": {
		high: 23.6231323,
		low: 13.30344769
	},
	"2025-12-03": {
		high: 23.67290367,
		low: 13.26564789
	},
	"2025-12-04": {
		high: 24.17304985,
		low: 13.47349665
	},
	"2025-12-05": {
		high: 23.89725891,
		low: 13.36299356
	},
	"2025-12-08": {
		high: 23.83121871,
		low: 13.35777077
	},
	"2025-12-09": {
		high: 23.25865526,
		low: 13.00936954
	},
	"2025-12-10": {
		high: 23.09386219,
		low: 12.87805757
	},
	"2025-12-11": {
		high: 24.4988508,
		low: 13.43972712
	},
	"2025-12-12": {
		high: 24.37820543,
		low: 13.62129674
	},
	"2025-12-15": {
		high: 24.70086719,
		low: 13.80890347
	},
	"2025-12-16": {
		high: 24.42087118,
		low: 13.57825075
	},
	"2025-12-17": {
		high: 24.20297223,
		low: 13.53356729
	},
	"2025-12-18": {
		high: 24.03760338,
		low: 13.44198346
	},
	"2025-12-19": {
		high: 24.50193673,
		low: 13.60395246
	},
	"2025-12-22": {
		high: 24.74860744,
		low: 13.80798733
	},
	"2025-12-23": {
		high: 25.18927466,
		low: 13.98853187
	},
	"2025-12-24": {
		high: 24.87446787,
		low: 13.91113036
	},
	"2025-12-29": {
		high: 25.11478482,
		low: 14.0772888
	},
	"2025-12-30": {
		high: 25.50405655,
		low: 14.15155381
	},
	"2025-12-31": {
		high: 24.89191353,
		low: 13.9791763
	},
	"2026-01-02": {
		high: 25.25935346,
		low: 14.03600316
	},
	"2026-01-05": {
		high: 25.11730944,
		low: 14.02620825
	},
	"2026-01-06": {
		high: 25.67629466,
		low: 14.30310018
	},
	"2026-01-07": {
		high: 25.77246153,
		low: 14.50270987
	},
	"2026-01-08": {
		high: 24.90473544,
		low: 13.86041872
	},
	"2026-01-09": {
		high: 26.01145638,
		low: 14.61672594
	},
	"2026-01-12": {
		high: 28.141796,
		low: 15.63429762
	},
	"2026-01-13": {
		high: 27.92766915,
		low: 15.79181542
	},
	"2026-01-14": {
		high: 27.84750937,
		low: 15.81347994
	},
	"2026-01-15": {
		high: 28.13969377,
		low: 16.01607405
	},
	"2026-01-16": {
		high: 28.83347473,
		low: 16.36784834
	},
	"2026-01-19": {
		high: 28.74232202,
		low: 15.70306958
	},
	"2026-01-20": {
		high: 28.31934697,
		low: 15.41856571
	},
	"2026-01-21": {
		high: 28.32710287,
		low: 15.91572584
	},
	"2026-01-22": {
		high: 29.2204461,
		low: 16.32186059
	},
	"2026-01-23": {
		high: 30.00930553,
		low: 16.60929357
	},
	"2026-01-27": {
		high: 29.7238367,
		low: 15.9773124
	},
	"2026-01-28": {
		high: 29.23017354,
		low: 15.90837653
	},
	"2026-01-29": {
		high: 28.70550435,
		low: 15.69678515
	},
	"2026-01-30": {
		high: 28.39268193,
		low: 15.53430501
	},
	"2026-02-02": {
		high: 27.49345245,
		low: 15.28826443
	},
	"2026-02-03": {
		high: 28.05982726,
		low: 15.60551147
	},
	"2026-02-04": {
		high: 28.42189227,
		low: 15.65593171
	},
	"2026-02-05": {
		high: 28.2333391,
		low: 15.73328756
	},
	"2026-02-06": {
		high: 28.01504013,
		low: 15.29332847
	},
	"2026-02-09": {
		high: 28.72702519,
		low: 15.84745723
	},
	"2026-02-10": {
		high: 28.21671866,
		low: 15.63961218
	},
	"2026-02-11": {
		high: 32.40053873,
		low: 16.68939008
	},
	"2026-02-12": {
		high: 32.01496981,
		low: 17.53807734
	},
	"2026-02-13": {
		high: 31.48893431,
		low: 17.37515532
	},
	"2026-02-16": {
		high: 31.28450549,
		low: 17.2661846
	},
	"2026-02-17": {
		high: 30.95145328,
		low: 17.17904159
	},
	"2026-02-18": {
		high: 30.45942616,
		low: 16.92898433
	},
	"2026-02-19": {
		high: 30.45672381,
		low: 16.91709346
	},
	"2026-02-20": {
		high: 30.08010879,
		low: 16.67219084
	},
	"2026-02-23": {
		high: 29.91874965,
		low: 16.56711956
	},
	"2026-02-24": {
		high: 29.62262687,
		low: 16.45121692
	},
	"2026-02-25": {
		high: 30.77997008,
		low: 17.06769411
	},
	"2026-02-26": {
		high: 29.930523,
		low: 16.57209724
	},
	"2026-02-27": {
		high: 29.85745583,
		low: 16.48405645
	},
	"2026-03-02": {
		high: 28.95677332,
		low: 16.27521245
	},
	"2026-03-03": {
		high: 28.36546238,
		low: 15.77010838
	},
	"2026-03-04": {
		high: 27.58464596,
		low: 15.09805552
	},
	"2026-03-05": {
		high: 26.54990016,
		low: 15.09485578
	},
	"2026-03-06": {
		high: 26.68297621,
		low: 15.02078168
	},
	"2026-03-09": {
		high: 25.41182462,
		low: 14.00005715
	},
	"2026-03-10": {
		high: 25.88471478,
		low: 14.57900468
	},
	"2026-03-11": {
		high: 25.34020781,
		low: 14.45276392
	},
	"2026-03-12": {
		high: 24.60898538,
		low: 13.98818333
	},
	"2026-03-13": {
		high: 23.73766281,
		low: 13.62248461
	},
	"2026-03-16": {
		high: 24.08262231,
		low: 13.67218023
	},
	"2026-03-17": {
		high: 24.22925322,
		low: 13.66481304
	},
	"2026-03-18": {
		high: 24.52074995,
		low: 13.9139047
	},
	"2026-03-19": {
		high: 24.24268192,
		low: 13.79043382
	},
	"2026-03-20": {
		high: 23.38663801,
		low: 13.31513305
	},
	"2026-03-23": {
		high: 22.9918567,
		low: 12.80417879
	},
	"2026-03-24": {
		high: 23.79020979,
		low: 13.30281399
	},
	"2026-03-25": {
		high: 23.89212696,
		low: 13.50689796
	},
	"2026-03-26": {
		high: 23.51855931,
		low: 13.27344862
	},
	"2026-03-27": {
		high: 22.54740313,
		low: 12.83739753
	},
	"2026-03-30": {
		high: 21.66287578,
		low: 12.37662755
	},
	"2026-03-31": {
		high: 21.71009053,
		low: 12.12273156
	},
	"2026-04-01": {
		high: 23.38779496,
		low: 13.12044903
	},
	"2026-04-02": {
		high: 23.31521401,
		low: 13.03214306
	},
	"2026-04-07": {
		high: 23.40254867,
		low: 13.10062532
	},
	"2026-04-08": {
		high: 24.99982393,
		low: 13.72612087
	},
	"2026-04-09": {
		high: 24.68586962,
		low: 13.86384987
	},
	"2026-04-10": {
		high: 24.91616246,
		low: 13.90441151
	},
	"2026-04-13": {
		high: 24.9255129,
		low: 13.83448234
	},
	"2026-04-14": {
		high: 25.50609018,
		low: 14.15066475
	},
	"2026-04-15": {
		high: 25.52953573,
		low: 14.21688923
	},
	"2026-04-16": {
		high: 24.22940608,
		low: 13.47269664
	},
	"2026-04-17": {
		high: 24.34431163,
		low: 13.613143
	},
	"2026-04-20": {
		high: 25.85442175,
		low: 14.20417265
	},
	"2026-04-21": {
		high: 26.30988051,
		low: 14.77204814
	},
	"2026-04-22": {
		high: 26.63631678,
		low: 15.02178091
	},
	"2026-04-23": {
		high: 26.40492687,
		low: 14.76229881
	},
	"2026-04-24": {
		high: 26.83936268,
		low: 15.03274471
	},
	"2026-04-27": {
		high: 26.56934726,
		low: 14.91720329
	},
	"2026-04-28": {
		high: 26.7267871,
		low: 15.00376289
	},
	"2026-04-29": {
		high: 26.1641808,
		low: 14.74264557
	},
	"2026-04-30": {
		high: 25.34627235,
		low: 14.01251787
	},
	"2026-05-01": {
		high: 25.44676621,
		low: 14.24863046
	},
	"2026-05-04": {
		high: 25.13043977,
		low: 14.05689112
	},
	"2026-05-05": {
		high: 24.13151677,
		low: 13.47952323
	},
	"2026-05-06": {
		high: 24.49528937,
		low: 13.7685137
	},
	"2026-05-07": {
		high: 25.62376095,
		low: 14.2840415
	},
	"2026-05-08": {
		high: 24.96577203,
		low: 13.83398127
	},
	"2026-05-11": {
		high: 25.21958431,
		low: 14.07817346
	},
	"2026-05-12": {
		high: 24.52277021,
		low: 13.7860067
	},
	"2026-05-13": {
		high: 24.48268604,
		low: 13.73502145
	},
	"2026-05-14": {
		high: 23.93865881,
		low: 13.38057598
	},
	"2026-05-15": {
		high: 23.63133403,
		low: 13.23727558
	},
	"2026-05-18": {
		high: 23.27801187,
		low: 12.69034311
	},
	"2026-05-19": {
		high: 23.50159085,
		low: 13.15762318
	}
};
